<template>
  <div>
    <button
      v-for="button in list"
      @click="updateScore(button.score)"
      :class="{'active': button.score === item.score}"
    >
      {{button.label}}
    </button>
  </div>
</template>

<script>

export default {
  name: 'DayTitle',
  components: {

  },
  props: [
    'item'
  ],
  data() {
    return {
      list: [
        {label:'Good', score:3},
        {label:'Soso', score:2},
        {label:'Bad', score:1},
      ]
    };
  },
  methods: {
    updateScore(score) {
      this.$emit('onUpdateScore', this.item, score);
    }
  },
  computed: {

  },
  created() {
    // console.log(this.item);
  },
  watch: {

  }
};

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DayScore.vue